
import { Component } from 'nuxt-property-decorator'
import LazyHydrate from 'vue-lazy-hydration'
import AliasPage from '@pp-frontend/shared-packages/modules/static/pages/AliasPage'
import { Context } from '@nuxt/types'
import Banner from '~/components/Banner.vue'
import ExpertBlock from '~/components/ExpertBlock.vue'
import Socials from '~/components/Socials.vue'
import SearchFormStatic from '~/components/search-form/SearchFormStatic.vue'

@Component({
  layout: 'default',
  components: {
  SearchFormStatic,
  ExpertBlock,

  Banner,
  LazyHydrate,
  Preloader: () => import('~/components/Preloader.vue'),
  Socials
  }
  })
export default class extends AliasPage {
  popupComponent: any = () => import('~/components/Popup.vue')

  head () {
    const link = [
      { rel: 'canonical', href: 'https://оплатагибдд.рф' + this.$route.path.replace('/amp', '') }
    ]

    return {
      title: this.article.title_browser,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.article.meta_description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.article.meta_keywords
        }
      ],
      link
    }
  }

  async asyncData (context: Context): Promise<any> {
    const {
      article,
      articles
      // @ts-ignore
    } = await AliasPage.options.asyncData(context)

    if (article.category_id === 'news' && context.route.path.startsWith('/static-page')) {
      return context.redirect(301, '/articles/' + context.params.alias)
    } else if (article.category_id === 'pages' && context.route.path.startsWith('/articles')) {
      return context.redirect(301, '/static-page/' + context.params.alias)
    }

    return {
      article,
      articles
    }
  }
}
